import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import {
  mutation as insertAnalyticsFileVersionMutation,
  buildVariables,
} from './insert-analytics-file-version-mutation-builder';

export default function useInsertAnalyticsFileVersion(options = {}) {
  const [executeMutation, response] = useMutation(insertAnalyticsFileVersionMutation, {
    context: { permission: permissions.updatePipelineAJSBuilder },
    ...options,
  });

  const insertMutation = ({ analyticsFileId, buildType, syncInjectorVersion, syncVersionRows }) => {
    return executeMutation({
      variables: buildVariables({ analyticsFileId, buildType, syncInjectorVersion, syncVersionRows }),
    });
  };

  return [insertMutation, response];
}
